import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  Inject
} from "@angular/core";
import { TrainSchedule } from "../../models/train-schedule";
import { NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Train } from "../../../trains/models/train";
import { Output } from "@angular/core";
import { EventEmitter } from "@angular/core";
import { TimetableEntry } from "../../models/timetable-entry";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { ReferenceArea } from "../../../reference-areas/models/reference-area";
import { FormValidationService } from '../../../../shared/services/form-validation.service';

@Component({
  selector: "app-train-schedule-edit",
  template: require('./train-schedule-edit.component.html'),
  styles: [require('./train-schedule-edit.component.sass')]
})
export class TrainScheduleEditComponent implements OnInit {
  @ViewChild("trainScheduleEditModal") trainScheduleEditModal: ElementRef;

  trainScheduleEditModalReference: NgbModalRef;
  @Input() trainIdentifier: {
    fieldName: string;
    displayedName: string;
  };
  @Input() trains: Train[];
  @Input() timetable: TimetableEntry[];
  @Input() trainRelativeId: number;
  @Input() projectId: number;
  @Input() scheduleDate: Date;
  @Input() referenceAreas: ReferenceArea[];

  @Output() save = new EventEmitter<TrainSchedule>();
  @Output() delete = new EventEmitter<TrainSchedule>();

  trainScheduleForm: FormGroup;
  serviceId: string;
  currentTrainSchedule: TrainSchedule | undefined;

  constructor(
    private modalService: NgbModal,
    @Inject("TimeZoneFactory") private timeZoneFactory: any,
    private fb: FormBuilder,
    public formValidation: FormValidationService
) {
    this.trainScheduleForm = this.fb.group({
      trainRelativeId: ["", Validators.required],
      serviceId: ["", Validators.required],
      start: [
        {
          hour: new Date().getHours(),
          minute: new Date().getMinutes()
        },
        Validators.required
      ],
      end: [
        {
          hour: new Date().getHours(),
          minute: new Date().getMinutes()
        },
        Validators.required
      ],
      startStation: ["", Validators.required],
      endStation: ["", Validators.required]
    });

    this.trainScheduleForm.controls["serviceId"].valueChanges.subscribe(
      serviceId => {
        const timetableEntry = this.timetable.find(
          entry => entry.serviceId === serviceId
        );
        if (timetableEntry) {
          const start = timetableEntry.start && timetableEntry.start.split(":");
          const end = timetableEntry.end && timetableEntry.end.split(":");
          this.trainScheduleForm.controls["start"].patchValue(
            {
              "hour": parseInt(start && start[0]) || 0,
              "minute": parseInt(start && start[1]) || 0
            }
          );
          this.trainScheduleForm.controls["end"].patchValue(
            {
              "hour": parseInt(end && end[0]) || 0,
              "minute": parseInt(end && end[1]) || 0
            }
          );
          this.trainScheduleForm.controls["startStation"].patchValue(
            timetableEntry.startStation
          );
          this.trainScheduleForm.controls["endStation"].patchValue(
            timetableEntry.endStation
          );
        }
      }
    );
  }

  ngOnInit(): void {}

  async showModal(trainSchedule?: TrainSchedule) {
    this.trainScheduleForm.reset();
    this.currentTrainSchedule = trainSchedule;
    if (this.currentTrainSchedule) {
      this.serviceId = this.currentTrainSchedule.timeTableEntry.serviceId;
      this.trainRelativeId = this.currentTrainSchedule.trainId;
      const start = this.currentTrainSchedule.timeTableEntry.start && this.currentTrainSchedule.timeTableEntry.start.split(":");
      const end = this.currentTrainSchedule.timeTableEntry.end && this.currentTrainSchedule.timeTableEntry.end.split(":");
      let startWaypoint: ReferenceArea | undefined;
      let endWaypoint: ReferenceArea | undefined;
      const timeTableEntry = this.currentTrainSchedule.timeTableEntry;
      if (timeTableEntry) {
         startWaypoint = this.referenceAreas && this.referenceAreas.find(waypoint => waypoint.id === timeTableEntry.startStation);
         endWaypoint = this.referenceAreas && this.referenceAreas.find(waypoint => waypoint.id === timeTableEntry.endStation);
      }
      
      this.trainScheduleForm.patchValue({
        serviceId: this.currentTrainSchedule.timeTableEntry.serviceId,
        trainRelativeId: this.currentTrainSchedule.trainId,
        start: {
          "hour": parseInt(start && start[0]) || 0,
          "minute": parseInt(start && start[1]) || 0
        },
        end: {
          "hour": parseInt(end && end[0]) || 0,
          "minute": parseInt(end && end[1]) || 0,
        },
        startStation: startWaypoint && startWaypoint.id,
        endStation: endWaypoint && endWaypoint.id
      });
      
    } else {
      this.trainScheduleForm.controls["trainRelativeId"].patchValue(this.trainRelativeId);
    }
    this.trainScheduleEditModalReference = await this.modalService.open(
      this.trainScheduleEditModal,
      {
        size:"xl",
        backdrop: "static"
      }
    );
  }

  onDelete = () => {
    this.delete.emit(this.currentTrainSchedule);
    this.trainScheduleEditModalReference.close();
  }

  onSave = () => {
    if (this.trainScheduleForm.valid){
    const startWaypoint: ReferenceArea | undefined = this.referenceAreas.find(waypoint => waypoint.id === this.trainScheduleForm.value.startStation);
    const endWaypoint: ReferenceArea | undefined = this.referenceAreas.find(waypoint => waypoint.id === this.trainScheduleForm.value.endStation);
    let timeTableEntry: TimetableEntry = {
      serviceId: this.trainScheduleForm.value.serviceId,
      start:  `${this.trainScheduleForm.value.start.hour}:${this.trainScheduleForm.value.start.minute}`,
      end:  `${this.trainScheduleForm.value.end.hour}:${this.trainScheduleForm.value.end.minute}`,
      projectId: this.projectId
    }
    if (startWaypoint) {
      timeTableEntry = {
        ...timeTableEntry,
        startStation: startWaypoint.id,
        startStationAbbr: startWaypoint.abbreviation
      }
    }
    if (endWaypoint) {
      timeTableEntry = {
        ...timeTableEntry,
        endStation: endWaypoint.id,
        endStationAbbr: endWaypoint.abbreviation
      }
    }
    this.save.emit({
      ...this.currentTrainSchedule,
      timestamp: this.timeZoneFactory
        .dateInCurrentTimeZone(this.scheduleDate)
        .format(),
      projectId: this.projectId,
      trainId:this.trainScheduleForm.value.trainRelativeId,
      timeTableEntry
    });
    this.trainScheduleEditModalReference.close();
    }
    else {
      this.formValidation.validateAllFormFields(this.trainScheduleForm)
    }
  };
}
